// extracted by mini-css-extract-plugin
export default {"header":"Header_header__9sERX","search":"Header_search__QikTh"};